import { NAVIGATION_ALLOWED_MARKETS, NAVIGATION_PATHS } from '../constants';
import { globalizationPath } from './globalizationPath';

export const resolveNavigationTarget = ({ pathname = '', market, lang, allowNavigation }) => {
  if (!allowNavigation || !NAVIGATION_ALLOWED_MARKETS.includes(market)) return null;
  const baseIndex = pathname.indexOf(NAVIGATION_PATHS.base);
  if (baseIndex < 0) return null;
  return globalizationPath(market, lang, pathname.slice(baseIndex));
};

export default resolveNavigationTarget;
